import { z } from "zod";

const signUpParams = z.object({
  source: z.string().optional(),
  r: z.string().optional(),
});

export { signUpParams };
